module.exports = __webpack_public_path__ + "img/icon-footer-blog.53bdcddb.jpg";